import UploadIcon from "@mui/icons-material/Upload";
import {Typography} from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";
import React from "react";


const AddImageButton = (props) => {
    const {onImagesSelection} = props

    return <ButtonBase component='label' sx={{
        width: '100%',
        height: '100%',
        border: '2px dashed #ddd',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        orderPosition: -1,
    }}>
        <UploadIcon sx={{fontSize: 60}}/>
        <Typography textAlign="center">Nuova immagine</Typography>
        <input type='file' hidden accept="image/*" multiple onChange={onImagesSelection}/>
    </ButtonBase>
}

export default AddImageButton;